import React, {useEffect, useState} from "react";
import { Link, NavLink, useOutletContext } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {findKeysByName, imgHeight} from "../utils/helpers";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Autoplay, Pagination } from "swiper/modules";

// ✅ Reusable Industry Card
const IndustryCard = ({ title, desc, link }) => (
    <div className="col-12 col-md-6" data-aos="fade-up">
        <div className="card h-100 backGround">
            <div className="card-body rounded-3 shadow-md">
                <h5 className="card-title">{title}</h5>
                <p className="text-muted">{desc}</p>
                <Link to={link} className="text-decoration-none">
                    <div className="d-flex justify-content-start align-items-center">
                        <div
                            className="icon-circle m-0"
                            style={{ width: "30px", height: "30px", fontSize: "16px" }}
                        >
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                        <h6 className="brandColor text-uppercase mx-2 my-0">
                            Learn more
                        </h6>
                    </div>
                </Link>
            </div>
        </div>
    </div>
);

// ✅ Reusable Banner Slide
const BannerSlide = ({
                         imgMobile,
                         imgDesktop,
                         title1,
                         title2,
                         color = "white",
                         active,
                     }) => (
    <div
        className={`carousel-item ${active ? "active" : ""}`}
        data-bs-interval="2000"
    >
        {/* Responsive image (mobile vs desktop) */}
        <picture>
            <source media="(max-width: 768px)" srcSet={imgMobile} />
            <source media="(min-width: 769px)" srcSet={imgDesktop} />
            <img
                src={imgDesktop}
                className="img-fluid w-100"
                alt="Banner"
                style={{
                    mixBlendMode: "multiply",
                }}
            />
        </picture>

        <div
            className="d-flex flex-column justify-content-center align-items-center text-center"
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                padding: "1rem",
                color,
            }}
        >
            {/* Large screens */}
            <h2
                className="d-none d-lg-block text-uppercase p-2 bg-secondary bg-opacity-50"
                data-aos="zoom-in"
                style={{ letterSpacing: "5px" }}
            >
                {title1}
            </h2>
            <h5
                className="d-none d-lg-block text-uppercase"
                data-aos="zoom-in"
                style={{ letterSpacing: "10px" }}
            >
                {title2}
            </h5>

            {/* Small/medium screens */}
            <h4
                className="d-block d-lg-none p-2 text-uppercase bg-secondary bg-opacity-50"
                data-aos="zoom-in"
                style={{ letterSpacing: "5px" }}
            >
                {title1}
            </h4>
            <h6
                className="d-block d-lg-none p-2 text-uppercase"
                data-aos="zoom-in"
                style={{ letterSpacing: "5px" }}
            >
                {title2}
            </h6>

            <a
                href="#ourProducts"
                className="btn btn-brand px-3 my-1 my-lg-3"
                data-aos="fade-up"
                aria-label="Explore products section"
                style={{ fontFamily: "Lato, sans-serif" }}
            >
                Explore More
            </a>
        </div>
    </div>
);

const products = [
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070810/RivetNuts_bnbobx.webp", name: "Rivet Nuts M5" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759242759/BlindStandoffs_ikm3w8.webp", name: "Blind Standoffs" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165612/HexWeldNuts_iwjqrc.webp", name: "Hex Weld Nuts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165595/CageNuts_xyfsdl.webp", name: "Cage Nuts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165597/CountersunkHead_sb9xs7.webp", name: "Countersunk Head" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165600/FlangeBolts_takwzg.webp", name: "Flange Bolts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165605/FlushHeadStuds_vskogx.webp", name: "Flush Head Studs" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165602/FlangeHeadRivet_ii2nh2.webp", name: "Flange Head Rivet" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165607/HeavyHexBolts_xx6h1o.webp", name: "Heavy Hex Bolts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165608/HexBolts_pgfidx.webp", name: "Hex Bolts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759171102/BlindNuts_g0g7wc.webp", name: "Blind Nuts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165644/SelfClinchingNuts_rksv6u.webp", name: "Self Clinching Nuts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165614/PanHeadScrew_crrleo.webp", name: "Pan Head Screw" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165647/SemiTabularRivets_bkvkfa.webp", name: "Semi Tabular Rivets" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165641/PopRivets_nloyn7.webp", name: "Pop Rivets" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165650/SolidRivets_gzdimd.webp", name: "Solid Rivets" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165653/ThroughStandoffs_fzxdeh.webp", name: "Standoffs" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165655/WeldBolt_ece24l.webp", name: "Weld Bolt" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759601197/ExternalCirclips_ivssyh.webp", name: "External Circlips" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759241582/SquareWeldNuts_txujdh.webp", name: "Square Weld Nuts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1760968659/ClosedEndRivetNuts_f1grgi.webp", name: "Closed End Hex Rivet" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070858/RivetNutFullHex_igmxuy.webp", name: "Full Hex Rivet Nuts" },
    { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1762070889/Pneumatic_Rivet_Gun_ao3cec.webp", name: "Pneumatic Rivet Gun" },
];

const Home = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const { openModal } = useOutletContext();
    const { height } = imgHeight(windowWidth);

    const renderBanner = () => (
        <div className="bg-secondary" style={{ overflow: "hidden" }}>
            <div
                id="mainBanner"
                className="carousel slide"
                data-bs-ride="carousel"
            >
                <div className="carousel-inner">
                    <BannerSlide
                        imgDesktop="https://res.cloudinary.com/dbirahuue/image/upload/v1759157231/BannerImg1-desktop_pat8g3.webp"
                        imgMobile="https://res.cloudinary.com/dbirahuue/image/upload/v1759157231/BannerImg1-mobile_z7m2e5.webp"
                        title1="Welcome To Vibha Enterprises"
                        title2="Engineered Fasteners for Automotive Industries"
                        active
                    />
                    <BannerSlide
                        imgDesktop="https://res.cloudinary.com/dbirahuue/image/upload/v1759157231/BannerImg2-desktop_khdhbf.webp"
                        imgMobile="https://res.cloudinary.com/dbirahuue/image/upload/v1759157231/BannerImg2-mobile_y7gic4.webp"
                        title1="Your Trusted Partner"
                        title2="Fastening the Future — One Innovation at a Time."
                    />
                    <BannerSlide
                        imgDesktop="https://res.cloudinary.com/dbirahuue/image/upload/v1759157231/BannerImg3-desktop_onrnrm.webp"
                        imgMobile="https://res.cloudinary.com/dbirahuue/image/upload/v1759157231/BannerImg3-mobile_jausba.webp"
                        title1="Driving The Future"
                        title2="Precision Fasteners Built for the Roads of Tomorrow."
                    />
                </div>

                <button
                    className="carousel-control-prev d-none d-md-block"
                    type="button"
                    data-bs-target="#mainBanner"
                    data-bs-slide="prev"
                >
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next d-none d-md-block"
                    type="button"
                    data-bs-target="#mainBanner"
                    data-bs-slide="next"
                >
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );


    const renderDetails = ({openModal}) => (
        <div className="px-3 pt-4 pb-5">
            <div className="row row-cols-1 row-cols-lg-2">
                {/* Left */}
                <div className="col pb-5 pb-lg-0 ">
                    <h4 className="text-uppercase m-0">Vibha Enterprises</h4>
                    <h6 className="text-secondary">
                        Where Innovation Meets Strength in Every Thread.
                    </h6>
                    <p className="text-muted mb-2 text-justify" data-aos="fade-up">
                        Founded in 2017 in Moshi, Pune, Vibha Enterprises is an ISO 9001:2015 certified company, recognized as a trusted supplier, importer, and service provider of both standard and special fasteners. With a strong commitment to quality, precision, and customer-focused solutions, we cater to diverse industrial requirements, with particular expertise in the automotive and electric vehicle sectors.</p>
                    <p className="text-muted mb-2 text-justify" data-aos="fade-up">
                        Our comprehensive product portfolio includes advanced fastening solutions such as M5 Semi-Hex Nut Inserts, Self-Clinching Blind Nuts, Weld Nuts, and Special Stand-offs. Vibha Enterprises provides specially engineered fasteners. These solutions are designed to meet the unique challenges of electric mobility by offering:</p>
                    <ul className="text-muted" data-aos="fade-up">
                        <li>High vibration resistance</li>
                        <li>Corrosion protection</li>
                        <li>Lightweight design</li>
                        <li>Electrical insulation where required</li>
                    </ul>
                    <button
                        type="button"
                        className="btn btn-brand"
                        onClick={() => {
                            openModal("ISO Certification", "image-iso");
                        }}
                        data-aos="fade-up"
                    >
                        ISO Certification
                    </button>
                </div>

                {/* Right */}
                <div className="col">
                    <h4 className="text-center text-uppercase pb-1" data-aos="fade-up">Industries</h4>
                    <div className="row g-3">
                        <IndustryCard
                            title="Electrical & Automotive"
                            desc="Durable fasteners for secure, easy-to-maintain electrical enclosures."
                            link="/electricalAutomotive"
                        />
                        <IndustryCard
                            title="Metal Fabrication & Assembly"
                            desc="Reliable fasteners for strong, precise metal fabrication and assembly."
                            link="/metalFabricationAssembly"
                        />
                        <IndustryCard
                            title="Automated Machinery"
                            desc="High-strength fasteners for reliable, precision-built automated machinery."
                            link="/automatedMachinery"
                        />
                        <IndustryCard
                            title="Consumer Tech & Plastics"
                            desc="Fasteners for precision-built consumer electronics and plastic products."
                            link="/consumerTechPlastics"
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    // 🔹 Fixed: added return inside map
    const renderProducts = ({ findKeysByName }) => {
        return (
            <div className="container px-3 px-lg-0 pb-4" id="ourProducts">
                <h4 className="text-center pb-3 text-uppercase" data-aos="fade-up">
                    Our Products
                </h4>

                <Swiper
                    modules={[Autoplay, Pagination]}
                    spaceBetween={15}
                    slidesPerView={2}
                    slidesPerGroup={2}  // ✅ moves 4 slides per swipe or autoplay step
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    speed={800}
                    loop={true}
                    breakpoints={{
                        768: { slidesPerView: 3, slidesPerGroup: 3 },
                        1200: { slidesPerView: 4, slidesPerGroup: 4 },
                    }}
                >
                    {products.map((product, i) => {
                        const keys = findKeysByName ? findKeysByName(product.name) : null;

                        const cardContent = (
                            <div
                                className="card bg-light shadow-sm h-100"
                                data-aos="fade-up"
                                style={{ borderRadius: "10px", overflow: "hidden" }}
                            >
                                <img
                                    src={product.src}
                                    className="card-img-top"
                                    alt={product.name}
                                    style={{
                                        height: window.innerWidth <= 576 ? "150px" : "200px",
                                        width: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                                <p className="text-dark text-center py-2 mb-0">{product.name}</p>
                            </div>
                        );

                        return (
                            <SwiperSlide key={i}>
                                {keys ? (
                                    <NavLink
                                        to={`/products/${keys.categoryKey}/${keys.typeKey}`}
                                        onClick={() => window.scrollTo(0, 0)}
                                        style={{ textDecoration: "none" }}
                                    >
                                        {cardContent}
                                    </NavLink>
                                ) : (
                                    cardContent
                                )}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        );
    };

    const renderCallback = ({openModal}) => (
        <div className="mx-3 px-1 py-5 backGround" data-aos="fade-up">
            <h5 className="text-center text-uppercase brandColor mb-1" >Get Started</h5>
            <h2 className="d-none d-lg-block text-center mb-2"> Take your first step toward growth and success with us today.</h2>
            <h4 className="d-block d-lg-none text-center mb-2"> Take your first step toward growth and success with us today.</h4>
            <p className="text-center mb-3">Need help? Request a callback and our team will guide you.</p>
            <div className="d-flex justify-content-center align-items-center">
                <button
                    type="button"
                    className="btn btn-brand"
                    onClick={() => {
                        openModal("Request a Callback", "form-callback");
                    }}
                >
                    Request a Callback
                </button>
            </div>
        </div>
    );

    const renderAdditionalInfo = () => (
        <div className="px-4 px-lg-5 py-5">
            <h4 className="text-center text-uppercase pb-2" data-aos="fade-up">Industry Preferred</h4>
            <div className="row justify-content-center align-items-center">
                <div className="col-12 col-lg-5 mx-2 mx-lg-0 img-style" data-aos="fade-up">
                    <LazyLoadImage src="https://res.cloudinary.com/dbirahuue/image/upload/v1759168604/CarImg_vdvh3x.webp" className="img-fluid" alt="car" style={{ height: height, width: "100%"}} />
                </div>
                <div className="col-12 col-lg-6 px-0 pt-4 pt-lg-0 ps-lg-4 h-10" data-aos="fade-up">
                    <div className="card rounded-3 shadow-md backGround">
                        <div className="card-body p-4 text-justify">
                            <h5 className="card-title">
                                Special Fasteners — Engineered for the Future of Mobility
                            </h5>
                            <ul className="text-muted mb-2">
                                <li className="fw-semibold">
                                    Energy Storage Enclosure
                                    <p className="fw-normal text-muted mb-2">Specially engineered fasteners for secure, vibration-resistant connections, ensuring energy pack stability and safety in demanding environments.</p>
                                </li>
                                <li className="fw-semibold">
                                    Thin Sheet Assemblies
                                    <p className="fw-normal text-muted mb-2">High-strength fasteners that protect lightweight structures, ensuring durability and performance without damage.</p>
                                </li>
                                <li className="fw-semibold">
                                    Advanced Applications
                                    <p className="fw-normal text-muted mb-2">Fasteners built for tough conditions with superior corrosion resistance, long life, and consistent performance.</p>
                                </li>
                            </ul>
                            <p className="card-text text-muted">
                                Chosen by leading automakers for consistent performance, durability, and superior corrosion resistance.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const renderText = () => {
        return (
            <div className="mx-3 px-1 py-5 backGround" data-aos="fade-up">
                <h2 className="d-none d-lg-block text-center">Trusted by Leading Automotive & Electric Vehicle Manufacturers</h2>
                <h5 className="d-block d-lg-none text-center">Trusted by Leading Automotive & Electric Vehicle Manufacturers</h5>
                <p className="text-center mb-0">We deliver products as per your specifications and requirements.</p>
            </div>
        )
    };

    return (
        <div className="container-fluid p-0">
            {renderBanner()}
            {renderDetails({openModal})}
            {renderProducts({ findKeysByName })}
            {renderCallback({openModal})}
            {renderAdditionalInfo()}
            {renderText()}
        </div>
    );
};

export default Home;
